import { Incoterms } from 'api';

const INCOTERMS_WITH_COLLECTION_FROM_PORT: Incoterms[] = [Incoterms.CIF, Incoterms.CFR, Incoterms.FOB];

export const isCollectionFromPort = (incoterm: Incoterms): boolean => {
  return INCOTERMS_WITH_COLLECTION_FROM_PORT.includes(incoterm);
};
